// bildirimOlayi.js — ZİL ANINDA TAZELENİR (29 Eyl 2026)
//
// 🔑 Serkan (29 Eyl, sahadan): *"Eğitim güncelledim, sayacın doğru çalışması
//    için sayfa yenilemek gerekti."* · *"Eğitim ve lisans güncellemelerinde
//    sayacın da güncellenmesi."*
//
// 🔴 ÖLÇÜLDÜ: zil verisini yalnız açılışta ve 5 dakikada bir okuyordu
//    (`NotificationBell.js` `setInterval(load, 300000)`); TRAINING ya da
//    ATPL & MED kaydı zile hiç haber vermiyordu. Kayıt doğruydu, zil beş
//    dakikaya kadar ESKİ durumu gösteriyordu.
//
// ÇÖZÜM — en basit ve her koşulda çalışan: kayıt başarılı olunca bu olay
// atılır, zil dinler ve hemen yeniden okur. 5 dakikalık yoklama YEDEK olarak
// kalır (başka sekmede/başka kullanıcının yaptığı değişiklik için).
// Ayrı dosyada: zil, TRAINING, ATPL & MED ve FTL paneli birbirini import
// etmeden aynı olayı kullansın.
export const BILDIRIM_TAZELE = 'go2efb:bildirim-tazele';

/** Zile "veri değişti, yeniden oku" der. Tarayıcı dışında (test/SSR) sessizce
 *  hiçbir şey yapmaz — orada dinleyen bir zil de yoktur. */
export function bildirimleriTazele() {
  if (typeof window === 'undefined' || typeof window.dispatchEvent !== 'function') return;
  window.dispatchEvent(new Event(BILDIRIM_TAZELE));
}
